/* ==========================================================================
   NAVIGATION LOLLYDOLL · ouverture au survol (niveaux 2 et 3)
   · Actif uniquement : écran >= 990 px, pointeur fin avec survol (pas de
     tactile), et réglage ll_nav_hover coché (data-ll-hover sur la nav).
   · Délais d'intention : 80 ms à l'ouverture, 160 ms à la fermeture.
   · Le clic souris sur une entrée à sous-menu NAVIGUE vers sa collection
     (data-ll-url) : le panneau est déjà ouvert au survol, le clic sert
     l'achat. Vaut pour les univers ET les sous-entrées à flyout.
   · Clavier intact : Entrée et Espace déclenchent un click avec
     event.detail === 0, on laisse alors le natif Dawn (ouverture, Escape,
     focus). Tactile intact aussi (exclu par la media query pointer).
   · À l'ouverture d'un menu, on ferme ceux qui ne sont ni ancêtres ni
     descendants : un seul chemin ouvert à la fois.
   · Panneaux de niveau 2 : position fixe, calée sur l'origine réelle du
     repère et non sur la fenêtre. L'en-tête collant porte une
     transformation, et un élément fixé à l'intérieur se cale sur lui : la
     mesure et l'écriture ne parlaient pas du même repère, et le panneau
     descendait de la hauteur de la barre d'annonce. Voir adjustPanel.
   ========================================================================== */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 160;

  function setup() {
    var nav = document.querySelector('.ll-nav');
    if (!nav || nav.dataset.llBound === 'true') return;
    nav.dataset.llBound = 'true';

    var hoverEnabled = nav.dataset.llHover === 'true';
    var allDetails = nav.querySelectorAll('details');

    function closeDetails(details) {
      var summary = details.querySelector(':scope > summary');
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      var panel = details.querySelector(':scope > .header__submenu');
      if (panel) {
        panel.classList.remove('ll-panel-fixed', 'll-flyout--left');
        panel.style.left = '';
        panel.style.right = '';
        panel.style.top = '';
        panel.style.position = '';
        panel.style.zIndex = '';
        panel.style.maxHeight = '';
        panel.classList.remove('ll-panel-scroll');
      }
    }

    /* Recale le panneau dans l'écran après ouverture.
       · Panneau de niveau 2 : décalage horizontal en pixels (left recalculé).
       · Flyout de niveau 3 : bascule à gauche (classe) si débordement à
         droite, puis décalage en dernier recours.
       getBoundingClientRect pour les mesures (offsetTop/offsetLeft ne sont
       pas fiables dans un contexte positionné, leçon déjà apprise). */
    var MARGIN = 12;

    function adjustPanel(details) {
      var panel = details.querySelector(':scope > .header__submenu');
      var summary = details.querySelector(':scope > summary');
      if (!panel || !summary) return;
      var isFlyout = details.closest('.header__submenu') !== null;
      var vw = document.documentElement.clientWidth;

      /* Remise à zéro des corrections précédentes avant mesure */
      panel.style.left = '';
      panel.style.right = '';
      panel.style.top = '';
      panel.style.position = '';
      panel.style.zIndex = '';
      panel.style.maxHeight = '';
      panel.classList.remove('ll-flyout--left', 'll-panel-scroll');

      if (!isFlyout) {
        /* Niveau 2 : fixed sous l'entrée, pour échapper au clipping du
           scroller de rangée, puis borné dans l'écran. La position est
           posée en inline : le recalage fonctionne même si la feuille
           lollydoll-header.css servie est une version en cache */
        panel.classList.add('ll-panel-fixed');
        panel.style.position = 'fixed';
        panel.style.zIndex = '30';

        /* Origine réelle du référentiel.

           getBoundingClientRect mesure depuis la fenêtre, mais un élément en
           position fixe placé dans un ancêtre transformé se cale sur cet
           ancêtre, pas sur la fenêtre. L'en-tête collant porte justement une
           transformation : la mesure et l'écriture ne parlaient donc pas du
           même repère, et le panneau descendait de la distance entre le haut
           de la fenêtre et le haut de l'en-tête, soit la hauteur de la barre
           d'annonce. C'est le même piège que le voile de recherche.

           Plutôt que de deviner ce décalage, on le mesure : le panneau est
           posé à l'origine du repère, on regarde où il atterrit réellement,
           et tous les calculs suivants sont corrigés d'autant. Sans ancêtre
           transformé, l'origine vaut zéro et le comportement est inchangé. */
        panel.style.top = '0px';
        panel.style.left = '0px';
        panel.style.right = 'auto';

        /* Mesure prise sans animation ni transformation.

           Le panneau entre avec un léger glissement. À la première ouverture,
           la mesure tombait pendant ce mouvement : le script relevait un
           panneau encore décalé et écrivait sa position en conséquence, d'où
           un sous-menu trop bas. Aux ouvertures suivantes le glissement était
           déjà terminé et la position redevenait juste.

           On neutralise donc transition et transformation le temps de la
           mesure, puis on rend la main : l'animation reprend depuis la bonne
           position. */
        var transitionAvant = panel.style.transition;
        var transformAvant = panel.style.transform;
        var animationAvant = panel.style.animation;
        panel.style.transition = 'none';
        panel.style.transform = 'none';
        /* L'animation d'ouverture est neutralisée elle aussi. Une propriété
           animée l'emporte sur un style écrit sur l'élément : sans cette
           ligne, la transformation de l'animation continuait de s'appliquer
           pendant la mesure, et le panneau était relevé en pleine descente. */
        panel.style.animation = 'none';

        var origine = panel.getBoundingClientRect();

        var srect = summary.getBoundingClientRect();
        var prect = panel.getBoundingClientRect();
        var top = srect.bottom + 8;
        var left = Math.min(Math.max(srect.left, MARGIN), vw - prect.width - MARGIN);
        if (left < MARGIN) left = MARGIN;

        panel.style.top = (top - origine.top) + 'px';
        panel.style.left = (left - origine.left) + 'px';

        /* Position écrite, on rend l'animation. La lecture forcée de la
           disposition garantit que le navigateur applique d'abord la nouvelle
           position, puis anime : sans elle, il fusionnerait les deux et le
           panneau glisserait depuis son ancienne place. */
        void panel.offsetHeight;
        panel.style.transition = transitionAvant;
        panel.style.transform = transformAvant;
        panel.style.animation = animationAvant;

        /* Hauteur disponible sous l'entrée : au-delà, défilement interne.
           Mesures en coordonnées fenêtre des deux côtés, donc pas de
           correction à appliquer ici. */
        var avail = window.innerHeight - top - MARGIN;
        if (panel.scrollHeight > avail) {
          panel.style.maxHeight = avail + 'px';
          panel.classList.add('ll-panel-scroll');
        } else {
          panel.style.maxHeight = '';
          panel.classList.remove('ll-panel-scroll');
        }
        return;
      }

      /* Niveau 3 : bascule à gauche si débordement, décalage en dernier
         recours */
      var rect = panel.getBoundingClientRect();
      if (rect.right > vw - MARGIN) {
        panel.classList.add('ll-flyout--left');
        rect = panel.getBoundingClientRect();
      }
      var shift = 0;
      if (rect.right > vw - MARGIN) shift = vw - MARGIN - rect.right;
      if (rect.left + shift < MARGIN) shift = MARGIN - rect.left;
      if (shift !== 0) {
        panel.style.left = (panel.offsetLeft + shift) + 'px';
        panel.style.right = 'auto';
      }
    }

    function openDetails(details) {
      allDetails.forEach(function (d) {
        if (d !== details && d.hasAttribute('open') && !d.contains(details) && !details.contains(d)) {
          closeDetails(d);
        }
      });
      var summary = details.querySelector(':scope > summary');
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { adjustPanel(details); });
    }

    allDetails.forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;
      var openTimer = null;
      var closeTimer = null;

      /* Ouverture native (clic, clavier, survol) : recalage dans l'écran */
      details.addEventListener('toggle', function () {
        if (details.hasAttribute('open')) {
          requestAnimationFrame(function () { adjustPanel(details); });
        }
      });

      if (!hoverEnabled) return;

      details.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { openDetails(details); }, OPEN_DELAY);
      });

      details.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeDetails(details); }, CLOSE_DELAY);
      });

      /* Détection souris fiable sur tous les navigateurs : Safari peut
         envoyer detail:1 pour une activation clavier, on marque donc
         l'interaction pointeur soi-même. Clavier = jamais marqué =
         comportement natif d'ouverture. */
      summary.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') {
          summary.dataset.llMouse = '1';
        }
      });

      summary.addEventListener('click', function (event) {
        var fromMouse = summary.dataset.llMouse === '1';
        delete summary.dataset.llMouse;
        if (!mq.matches || !fromMouse) return;
        var url = summary.getAttribute('data-ll-url');
        if (url && url !== '#') {
          event.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  /* ---- Compteur du panier : « 99+ » au-delà de 99, et resynchronisation
     au retour arrière. Le panier lui-même est stocké côté Shopify, il ne
     peut pas être perdu ; c'est la PAGE qui peut être rejouée depuis le
     cache du navigateur avec un ancien compteur. On rafraîchit alors la
     valeur depuis /cart.js. ---- */
  function llCapBubble() {
    document.querySelectorAll('.cart-count-bubble > span:not(.visually-hidden)').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (!isNaN(n) && n > 99) el.textContent = '99+';
    });
  }

  function llSyncCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('#cart-icon-bubble, .ll-cart').forEach(function (icon) {
          var bubble = icon.querySelector('.cart-count-bubble');
          if (count > 0 && !bubble) {
            /* Le panier s'est rempli alors que la page montrait un panier
               vide : on recharge pour laisser Shopify rendre la pastille */
            window.location.reload();
            return;
          }
          if (count === 0 && bubble) { bubble.remove(); return; }
          if (bubble) {
            var span = bubble.querySelector('span:not(.visually-hidden)');
            if (span) span.textContent = count > 99 ? '99+' : count;
          }
        });
      })
      .catch(function () {});
  }

  llCapBubble();
  /* pageshow avec persisted = page servie depuis le cache (retour arrière) */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) llSyncCartCount();
    else llCapBubble();
  });
  document.addEventListener('shopify:section:load', llCapBubble);

  /* ---- Ouverture du panier tiroir depuis TOUTES les icônes panier ----
     Dawn n'attache l'ouverture qu'à #cart-icon-bubble au chargement. Le
     panier de la navigation desktop (et toute autre icône) n'est pas
     couvert : on délègue au niveau du document, ce qui vaut aussi pour les
     éléments re-rendus par l'éditeur ou par une mise à jour de section. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#cart-icon-bubble, .ll-cart, .ll-nav__utility a[href*="/cart"]');
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer');
    /* Pas de tiroir sur la page panier elle-même, ni si le tiroir est
       désactivé : on laisse le lien faire son travail. */
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(trigger);
  });

  /* Bouton de fermeture du tiroir mobile : ferme le details natif de Dawn
     et remet la classe d'animation à zéro (comme le fait son propre JS) */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.ll-drawer__close');
    if (!btn) return;
    var container = document.getElementById('Details-menu-drawer-container');
    if (!container) return;
    container.classList.remove('menu-opening');
    container.removeAttribute('open');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    var summary = container.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
      summary.focus();
    }
  });

  /* Un défilement de page ferme les menus ouverts (leurs panneaux sont en
     position fixe, ils ne suivraient pas) */
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.ll-nav details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector(':scope > summary');
      if (s) s.setAttribute('aria-expanded', 'false');
      var p = d.querySelector(':scope > .header__submenu');
      if (p) {
        p.classList.remove('ll-panel-fixed', 'll-flyout--left');
        p.style.left = '';
        p.style.right = '';
        p.style.top = '';
        p.style.position = '';
        p.style.zIndex = '';
        p.style.maxHeight = '';
        p.classList.remove('ll-panel-scroll');
      }
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  /* Re-rendu de la section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', setup);
})();